import Http from "./http";

export default {
  getDigitalContents: async (student_id, module_id, page, type) => {
    let data = await Http.get(`/videolessons`, {
        params: {
          module_id: module_id,
          type: type ? type : 'digitalcontent',
          page
        }
      });
    return data.data;
  },

  getDigitalContent: async (student_id, id, type) => {
    let data = await Http.get(`/videolessons/${id}`, {
        params: {
          type: type ? type : 'digitalcontent',
        }
      });
    return data.data;
  }
};
